import { NavigationModel } from "models/NavigationModel";

interface FooterLinksProps {
  heading: string;
  prefix: string;
  items: NavigationModel[];
}

export const FooterLinks: React.FC<FooterLinksProps> = ({ prefix, items, heading }) => {
  return (
    <>
      <h5>{heading}</h5>
      <div className="footer-links">
        {items.map((item, i) => {
          const { iconStart, text, hintText, iconEnd, href } = item;

          return (
            <div key={`footer-${prefix}-${i}`}>
              <a href={href} target="_blank" rel="noopener noreferrer" className="sbb-footer-nav-item">
                <span className="sbb-arrow-cta">
                  {iconStart ? <span className="me-2">{iconStart}</span> : null}
                  {text}
                  {hintText ? <small className="text-muted ps-2 pe-1">{hintText}</small> : null}
                  {iconEnd ? <span className="ms-2">{iconEnd}</span> : null}
                </span>
              </a>
            </div>
          );
        })}
      </div>
    </>
  );
};
